<!-- Hero Section (Full Width) -->
<div class="position-relative w-100 overflow-hidden">
    <div>
        <div class="position-relative w-100 overflow-hidden">
            <div class="d-block d-md-none text-center" style="height: 50px; background-color: #aab4bc"></div>
            <!-- Placeholder Hero Image -->
            <img src="https://d3uop73ba1wtqg.cloudfront.net/uploads/EWR0lvgdN8KIPhaRi7FRseH6FkM8duY0wxKXAajU.jpg"
                alt="Hero Image" class="img-fluid w-100" />
            <!-- <div
                class="position-absolute top-0 w-100 h-100 d-flex flex-column justify-content-center w-25 text-start px-3 px-md-5">
                <h1 class="headingBL title mb-3 text-white">
                    Complete Learning <br />Management Ecosystem
                </h1>
            </div> -->
        </div>
    </div>
</div>

<!-- Features Section -->
<section class="icon-features-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Key <span>Features</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="icon-features-grid">
            <div class="feature-item" *ngFor="let feature of features">
                <div class="icon-box">
                    <mat-icon>{{ feature.icon }}</mat-icon>
                    <div class="icon-bg"></div>
                </div>
                <h4 class="feature-title">{{ feature.title }}</h4>
                <p class="feature-desc">{{ feature.description }}</p>
            </div>
        </div>
    </div>
</section>

<!-- Dashboard Screenshots Section -->
<section class="gallery-section">
    <div class="container mb-5">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Dashboard</h2>
            <div class="title-underline"></div>
        </div>

        <div class="gallery-grid">
            <div class="gallery-item" *ngFor="let screen of dashboardScreenshots">
                <div class="img-wrapper">
                    <img [src]="screen.image" [alt]="screen.title" loading="lazy">
                    <div class="hover-overlay">
                        <mat-icon>zoom_in</mat-icon>
                    </div>
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-white mb-0">{{ screen.title }}</h5>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Pricing Plans Section -->
<!-- <section class="pricing-section py-5 bg-black">
    <div class="container">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Pricing <span>Plans</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-4 mb-4" *ngFor="let plan of pricingPlans">
                <div class="card h-100 shadow-sm border-1 border-white">
                    <div class="card-header bg-dark text-white border-bottom-1 border-white text-center py-4">
                        <h4 class="mb-0">{{ plan.name }}</h4>
                    </div>
                    <div class="card-body bg-black text-white">
                        <ul class="list-unstyled mb-4">
                            <li class="mb-2" *ngFor="let feature of plan.features">
                                <mat-icon class="align-middle me-2">check_circle</mat-icon>
                                {{ feature }}
                            </li>
                        </ul>
                        <div class="text-center plan text-white mx-auto">
                            <h5 class="font-weight-bold">{{ plan.price }}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- CTA Section -->
<section class="cta-section text-center">
    <div class="container cta-buttons">
        <a routerLink="/form/contactUs" class="btn-cta btn-cta-primary">
            <mat-icon>monetization_on</mat-icon>
            Inquire
        </a>
    </div>
</section>